import styled from 'styled-components';
import Input from './base/Input';

const FormControl = styled(Input)`
  font-family: inherit;
  border-radius: 3px;
  border: 1px solid gray;
  outline: 0;
  font-size: 18px;
  padding: 8px;
  ${({ pl }) => pl && `padding-left: ${pl};`}
  width: 100%;
  appearance: none;
  background-color: ${({ notValid }) => notValid && 'rgba(255, 0, 0, 0.05)'};
  transition: all 0.3s ease-in-out;
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    &,
    & + .addon {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export default FormControl;
